import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=35af33c6&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35af33c6')) {
      api.createRecord('35af33c6', component.options)
    } else {
      api.reload('35af33c6', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=35af33c6&", function () {
      api.rerender('35af33c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Projects/WeldLog/Index.vue"
export default component.exports